<template>
  <div class="main" style="height:89%">
    <div class="main_header">
      <div class="header_item">
        <span class="header_label">资料名称：</span>
        <el-input v-model="search.materialName" :size="size" clearable placeholder="请输入资料名称"></el-input>
      </div>
      <div class="header_item">
        <span class="header_label">资料类型：</span>
        <el-select v-model="search.materialType" placeholder="请选择资料类型" clearable>
            <el-option
                v-for="item in optionsType"
                :key="item.dictId"
                :label="item.dictName"
                :value="item.dictId">
            </el-option>
        </el-select>
      </div>
      <div class="header_item">
        <el-button icon="el-icon-search" v-if="showButton('search')" @click="searchButtonInfo(true)">查询</el-button>
        <el-button class="search_btn" icon="el-icon-plus" v-if="showButton('insert')" @click="insertProp">新增</el-button>
      </div>
    </div>
    <div class="main_content">
      <el-table
        v-loading="loading"
        :data="dataList"
        height="100%">
        <el-table-column align="center" label="序号" width="60">
          <template #default="scope">
            <span>{{(pageNum - 1) * pageSize + scope.$index + 1}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="materialName" label="资料名称" align="center" ></el-table-column>
        <el-table-column prop="dictName" label="资料类型" align="center" ></el-table-column>
        <el-table-column prop="materialNumber" label="资料编号" align="center" ></el-table-column>
        <el-table-column prop="materialVersion" label="资料版本" align="center"></el-table-column>
        <el-table-column label="操作" align="center" >
          <template #default="{ row }">
            <el-button class="table_btn" size="mini" v-if="showButton('update')" @click="updateProp(row)">修改</el-button>
            <el-button class="table_btn" size="mini" v-if="showButton('update')" @click="codeQR(row)">导出二维码</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="main_footer">
      <el-pagination
        background
        @current-change="changePageNum"
        @size-change="changePageSize"
        :current-page="pageNum"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <el-dialog
      class="prop_dialog"
      :title="asyncTitle ? '新增资料' : '修改资料'"
      :close-on-click-modal="false"
      :visible.sync="asyncVisible"
      width="35%">
      <el-form ref="ruleForm" :model="ruleForm" :rules="rules" label-width="auto" class="rule_form">
        <el-form-item label="资料名称：" prop="materialName">
          <el-input v-model="ruleForm.materialName" :size="size" clearable placeholder="请输入资料名称"></el-input>
        </el-form-item>
        <el-form-item label="资料类型：" prop="materialType">
          <el-select v-model="ruleForm.materialType" placeholder="请选择资料类型">
                <el-option
                v-for="item in optionsType"
                :key="item.dictId"
                :label="item.dictName"
                :value="item.dictId">
                </el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="资料编号：" prop="materialNumber">
          <el-input v-model="ruleForm.materialNumber" :size="size" clearable placeholder="请输入资料编号"></el-input>
        </el-form-item>
        <el-form-item label="资料版本：" prop="materialVersion">
          <el-input v-model="ruleForm.materialVersion" :size="size" clearable placeholder="请输入资料版本"></el-input>
        </el-form-item>
        <el-form-item label="文件上传：" prop="files">
          <upload-file :file-list.sync="ruleForm.files" :limit="limit">
                <template #info>
                    <span>点击上传文件，支持xls、xlsx、ppt、doc、docx、pdf格式</span>
                </template>
          </upload-file>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="asyncVisible = false">取 消</el-button>
        <el-button class="submit_btn" @click="asyncTitle ? submitInsert() : submitUpdate()">提 交</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import UploadFile from '@/components/uploadFile';
import { buttonPinia } from '../../../pinia/index';
import { throttle, changeSize,downLoadQR } from '../../../plugins/public'; // 导入节流、动态切换组件尺寸方法
  export default {
    components:{
       UploadFile
    },
    data() {
      return {
        limit:false,
        size: changeSize(), // 组件尺寸
        pageNum: 1,
        pageSize: 10,
        search:{},//查询条件
        optionsType:[],//资料类型
        total: 0,
        loading: false,
        dataList: [], //资料管理信息列表
        asyncTitle: true, // 对话框title 新增：true  修改：false
        asyncVisible: false, // 添加 修改对话框
        ruleForm: {
            files:[]
        }, // 按钮表单
        rules: {
          files: [{
            required: true,
            message: '请选择上传文件',
            trigger: ['blur','change']
          }],
          materialName: [{
            required: true,
            message: '请输入资料名称',
            trigger: 'blur'
          }],
          materialNumber: [{
            required: true,
            message: '请输入资料编号',
            trigger: 'blur'
          }],
          materialType: [{
            required: true,
            message: '请选择资料类型',
            trigger: 'change'
          }],
          materialVersion: [{
            required: true,
            message: '请输入资料版本',
            trigger: 'blur'
          }],
        },
      }
    },
    watch: {
      asyncVisible(bol) {
        if(!bol) {
          this.ruleForm = {};
          this.$refs.ruleForm.resetFields();
          this.limit = false
        }else{
          this.$set(this.ruleForm, 'files', []);
          this.limit = true
        }
      }
    },
    mounted() {
      const that = this;
      // 根据窗口大小动态修改组件尺寸
      window.onresize = () => {
        that.size = changeSize();
      }
      that.searchButtonInfo(true);
      that.getAllTypes()
    },
    methods: {
        //获取尺寸配筋转向等信息
      getAllTypes(){
        let params = {
            pageNum: 1,
            pageSize: 100000000,
            dictType:16
        }
        this.$api.Dictionary.searchDictionary(params).then(res=>{
            if(res.statusMsg === 'ok'){
                this.optionsType = res.data.list
            }else{
                this.$message.warning(res.statusMsg)
            }
        })
      },
      // 查询按钮列表信息
      searchButtonInfo(bol) {
        if(bol) {
          this.pageNum = 1;
        }
        let params = Object.assign({},this.search,{
          pageNum: this.pageNum,
          pageSize: this.pageSize
        })
        this.loading = true;
        this.$api.Safety.searchDatumLists(params).then((res) => {
          if(res.statusMsg === 'ok') {
            this.total = res.data.total;
            this.dataList = res.data.list;
          }
          this.loading = false;
        })
      },
      // 新增按钮信息
      insertProp() {
        this.asyncTitle = true;
        this.asyncVisible = true;
      },
      // 修改按钮信息
      updateProp(row) {
        this.asyncTitle = false;
        this.asyncVisible = true;
        this.$api.Safety.detailsDatumInfo({materialId: row.materialId}).then(res=>{
            if(res.statusMsg === 'ok'){
                this.ruleForm = res.data
                this.$set(this.ruleForm, 'files', res.data.materialPaths.map((item, index) => {
                    const type = item.materialPath.split('.');
                    return {
                        id: index + 1,
                        type: type[type.length - 1],
                        name: item.materialPathName,
                        url: item.materialPath
                    }
                }))
            }else{
                this.$message.warning(res.statusMsg)
            }
        })
      },
      // 导出二维码
      codeQR(row) {
        downLoadQR(row.materialNumber,'/htapi/materials/steelPrint/test')
      },
      // 提交添加按钮信息
      submitInsert: throttle(function() {
        this.$refs.ruleForm.validate((valid) => {
          if(valid) {
            const params = Object.assign({}, this.ruleForm);
            params.files = params.files&&params.files.map(item => {
               return item.url
            });
            this.$api.Safety.insertDatumInfo(params).then((res) => {
              if(res.statusMsg === 'ok') {
                this.asyncVisible = false;
                this.searchButtonInfo(true);
                this.$message.success('添加成功！');
              } else {
                this.$message.warning(res.statusMsg);
              }
            })
          }
        })
      }, 3000),
      // 提交修改按钮信息
      submitUpdate: throttle(function() {
        this.$refs.ruleForm.validate((valid) => {
          if(valid) {
            const params = Object.assign({}, this.ruleForm);
            params.files = params.files&&params.files.map(item => {
               return item.url
            });
            this.$api.Safety.updateDatumInfo(params).then((res) => {
              if(res.statusMsg === 'ok') {
                this.asyncVisible = false;
                this.searchButtonInfo(true);
                this.$message.success('修改成功！');
              } else {
                this.$message.warning(res.statusMsg);
              }
            })
          }
        })
      }, 3000),
      // 判断按钮权限信息
      showButton(str) {
        const pinia = buttonPinia();
        return pinia.$state.buttonInfo.includes(str);
      },      
      // 切换页数
      changePageNum(page) {
        this.pageNum = page;
        this.searchButtonInfo();
      },
      // 切换每页条数
      changePageSize(size) {
        this.pageSize = size;
        this.searchButtonInfo();
      }
    }
  }
</script>

<style lang="sass" scoped>
@import '../../../style/layout-main.scss';
</style>